export const clientTypes = [
    { id: 1, label: "Investor", value: "1" },
    { id: 2, label: "Corporate", value: "2" },
  ];